import { PodcastData } from '../types/podcast';

// In-memory cache for episode details
const episodeCache = new Map<string, PodcastData>();

/**
 * Get cached episode details
 * @param episodeId - The episode ID to look up
 * @returns The cached episode data or null if not found
 */
export const getCachedEpisodeDetails = (episodeId: string): PodcastData | null => {
  return episodeCache.get(episodeId) || null;
};

/**
 * Cache episode details
 * @param episodeId - The episode ID to cache
 * @param data - The episode data to cache
 */
export const cacheEpisodeDetails = (episodeId: string, data: PodcastData): void => {
  episodeCache.set(episodeId, data);
};

/**
 * Pre-warm the cache with frequently accessed episodes
 * This is a placeholder function that can be implemented based on your needs
 */
export const prewarmCache = async (): Promise<void> => {
  // Implement cache pre-warming logic here if needed
  // For example, fetch and cache popular episodes
}; 